<script lang="ts">
  import { onMount } from 'svelte'
  import { goto } from '@roxi/routify'
  import { LobbyState } from '../Organizations/observables'
  import { filter, switchMap } from 'rxjs/operators'
  import { attemptToAddPlayer } from '../Players/utilities'
  import TopBarPage from '../Navigation/TopLevelPages/TopBarPage.svelte'

  export let org_uid: string
  const lobby_state = LobbyState(org_uid)
  const lobby_opened = lobby_state.pipe(
    filter(lobby => lobby.status === 'Open'),
    switchMap(async () => attemptToAddPlayer(org_uid)),
  )
  onMount(() => {
    const sub = lobby_opened.subscribe(response => {
      if (response.status === 'Ok') {
        $goto('/')
      }
    })
    return () => sub.unsubscribe()
  })
</script>

<TopBarPage>
  {#if !$lobby_state}
    <p>Loading...</p>
  {:else if $lobby_state.status === 'Full'}
    <p>Waiting for someone in the Retro to exit.</p>
  {:else if $lobby_state.status === 'Closed'}
    <p>Waiting for someone to start the Retro.</p>
  {:else if $lobby_state.status === 'Open'}
    <p>Joining the Retro now...</p>
  {/if}
</TopBarPage>
